import React from 'react';
import { DayPickerProps } from 'react-day-picker/types/Props';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ReactDatePicker from './ReactDatePicker';
import { DatePickerLayout } from './ReactDayPickerStyles';

dayjs.extend(customParseFormat);

interface DatePickerProps {
  height?: number;
  width?: number;
  id?: string;
  onBlur?: () => void;
  onChange?: (dateString: string) => void;
  defaultValue?: string;
  className?: string;
}

const DatePicker = ({ height, width, onChange, defaultValue, className, ...props }: DatePickerProps) => {
  const isValidDate = dayjs(defaultValue, 'MM-DD-YYYY', true).isValid();

  const dayPickerProps: DayPickerProps = {
    ...(isValidDate && {
      selectedDays: dayjs(defaultValue, 'MM-DD-YYYY', true).toDate(),
    }),
  };
  return (
    <DatePickerLayout className={className} width={width} height={height}>
      <ReactDatePicker
        value={isValidDate ? dayjs(defaultValue, 'MM-DD-YYYY').toDate() : (defaultValue as string)}
        onChange={(dateString: string) => {
          onChange?.(dateString);
        }}
        dayPickerProps={dayPickerProps}
        {...props}
      />
    </DatePickerLayout>
  );
};
export default DatePicker;
